import { inject, Injectable } from '@angular/core';
import { InformationRace } from '../interfaces/information-race';
import { HttpClient } from '@angular/common/http';
import { map, Observable, of, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InformationRaceService {
  http = inject(HttpClient);
  cache: { [key: string]: InformationRace; } = {};

  getAllInformationRaceForRace (raceId: string) {
    return this.http.get('/api/informationRace/race/' + raceId + '/withRace').pipe(
      tap((infoRaces: InformationRace[]) => {
        infoRaces.forEach(infoRace => this.cache[infoRace.infoForRaceId + infoRace.infoAboutRaceId] = infoRace);
      })
    );
  };

  getNonHostileRaceCountForRaceId$ (raceId: string): Observable<number> {
    return this.http.get<number>('/api/informationRace/race/' + raceId + '/count');
  };

  getInformationRaceForRaceAndForeignRace (raceId: string, foreignRaceId: string) {
    let infoRace = this.cache[raceId + foreignRaceId];
    if (infoRace) {
      return of(infoRace);
    }
    return this.http.get<InformationRace>('/api/informationRace/race/' + raceId + '/' + foreignRaceId).pipe(
      tap((infoRace: InformationRace) => {
        this.cache[infoRace.infoForRaceId + infoRace.infoAboutRaceId] = infoRace;
      })
    );
  };

  getNonHostileRaces (raceId: string) {
    return this.http.get<InformationRace[]>('/api/informationRace/race/' + raceId + '/nonHostile').pipe(
      tap((infoRaces: InformationRace[]) => {
        infoRaces.forEach(infoRace => this.cache[infoRace.infoForRaceId + infoRace.infoAboutRaceId] = infoRace);
      })
    );
  };

  findOrCreateInformationRace (campaignId: string, raceId: string, otherRaceId: string, starSystemId: string, turn: number) {
    return this.http.put<InformationRace>('/api/informationRace/race/' + raceId + '/' + otherRaceId, {
      campaignId: campaignId,
      starSystemId: starSystemId,
      turn: turn
    }).pipe(
      tap((infoRace: InformationRace) => {
        this.cache[infoRace.infoForRaceId + infoRace.infoAboutRaceId] = infoRace;
      })
    );
  };

  saveInformationRace (informationRace: InformationRace): Observable<InformationRace> {
    let raceId = informationRace.infoForRaceId;
    let foreignRaceId = informationRace.infoAboutRaceId;
    this.cache[raceId + foreignRaceId] = informationRace;
    return this.http.put<InformationRace>('/api/informationRace/race/' + raceId + '/' + foreignRaceId, informationRace).pipe(
      tap((infoRace: InformationRace) => {
        this.cache[infoRace.infoForRaceId + infoRace.infoAboutRaceId] = infoRace;
      }),
      map((infoRace) => infoRace)
    );
  };
}
